import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { isAssistCardActive } from './assistRequest.slice';

const selectAssistRequest = (state: RootState) => state.assistRequest;

/** The assigned card, including one that has just ended (until dismissed). */
export const selectAssistCard = createSelector(
  selectAssistRequest,
  (state) => state.card
);

/** True while this agent holds a live card. */
export const selectIsAssistCardActive = createSelector(
  selectAssistCard,
  (card) => isAssistCardActive(card)
);

/** True while the pool has a card to show (live or ending). */
export const selectHasAssistPoolItems = createSelector(
  selectAssistRequest,
  (state) => Boolean(state.card)
);
